package com.iregained.site.components.sections.testimonials.sections

import androidx.compose.runtime.Composable
import com.iregained.site.components.sections.testimonials.styles.TestimonialsCtaPrimaryButtonStyle
import com.iregained.site.components.sections.testimonials.styles.TestimonialsCtaSecondaryButtonStyle
import com.iregained.site.components.widgets.SharedCtaWidget
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px

@Composable
fun TestimonialsCtaSection(data: TestimonialsCtaData = defaultTestimonialsCtaData) {
    SharedCtaWidget(
        headline = data.headline, description = data.description
    ) {
        if (data.primaryButtonText.isNotBlank() && data.primaryButtonPath.isNotBlank()) {
            Link(path = data.primaryButtonPath, modifier = Modifier.textDecorationLine(TextDecorationLine.None)) {
                Box(
                    modifier = TestimonialsCtaPrimaryButtonStyle.toModifier().padding(topBottom = 16.px)
                        .borderRadius(8.px).cursor(Cursor.Pointer), contentAlignment = Alignment.Center
                ) {
                    SpanText(
                        text = data.primaryButtonText, modifier = Modifier.fontSize(20.px).fontWeight(FontWeight.Bold)
                    )
                }
            }
        }

        // SECONDARY BUTTON (Transparent with White Outline)
        if (data.secondaryButtonText.isNotBlank() && data.secondaryButtonPath.isNotBlank()) {
            Link(path = data.secondaryButtonPath, modifier = Modifier.textDecorationLine(TextDecorationLine.None)) {
                Box(
                    modifier = TestimonialsCtaSecondaryButtonStyle.toModifier().padding(topBottom = 16.px)
                        .borderRadius(8.px).cursor(Cursor.Pointer), contentAlignment = Alignment.Center
                ) {
                    SpanText(
                        text = data.secondaryButtonText, modifier = Modifier.fontSize(20.px).fontWeight(FontWeight.Bold)
                    )
                }
            }
        }
    }
}

// ==========================================
// DATA MODELS
// ==========================================
data class TestimonialsCtaData(
    val sectionId: String? = null,
    val headline: String,
    val description: String,
    val primaryButtonText: String,
    val primaryButtonPath: String,
    val secondaryButtonText: String,
    val secondaryButtonPath: String
)

val defaultTestimonialsCtaData = TestimonialsCtaData(
    sectionId = "testimonials-cta",
    headline = "Ready to Begin Your Recovery Journey?",
    description = "Join the growing community of stroke survivors and forward-thinking clinics transforming rehabilitation.",
    primaryButtonText = "Find a Clinic",
    primaryButtonPath = "/contact",
    secondaryButtonText = "Request a Demo",
    secondaryButtonPath = "/contact"
)
